import {
  Icon,
  Stack,
  type StackProps,
  Typography,
} from '@ace-clublabs/shared-component-library';

interface ChipProps {
  label: string;
  onDelete?: () => void;
  sx?: StackProps['sx'];
}

const Chip: React.FC<ChipProps> = ({ label, onDelete, sx }) => {
  return (
    <Stack
      direction='row'
      spacing={1}
      sx={[
        {
          backgroundColor: 'white',
          border: '1px solid',
          borderColor: 'primary.700',
          borderRadius: '20px',
          px: 2,
          height: 40,
          justifyContent: 'center',
          alignItems: 'center',
          mr: 1,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      className='selected-result'
      data-testid='chip'
    >
      <Typography
        variant='b1Medium'
        sx={{
          whiteSpace: 'nowrap',
          color: 'primary.700',
          fontSize: { xs: '1rem' },
        }}
      >
        {label}
      </Typography>
      {onDelete ? (
        <button
          type='button'
          onClick={(event) => {
            event.stopPropagation();
            onDelete();
          }}
          aria-label={`Remove ${label}`}
          data-testid='chip-delete-button'
          style={{
            border: 'none',
            background: 'none',
            padding: 0,
            display: 'flex',
            cursor: 'pointer',
          }}
        >
          <Icon
            iconName='xmark-regular'
            sx={{
              color: 'primary.700',
              cursor: 'pointer',
              width: '1rem',
            }}
          />
        </button>
      ) : null}
    </Stack>
  );
};

export default Chip;
